import {
  INDIVIDUAL_SEPARATOR_IDENTIFIER,
  PAGE_SEPARATOR_IDENTIFIER
} from '@components/UI-Components/HierarchyWiseItems/constants'
import useHierarchyItemContext from '@components/UI-Components/HierarchyWiseItems/hooks/use-hierarchy-item-context'
import { extractIndexFromId } from '@utils/index-from-id'
import { useObserver } from 'mobx-react-lite'
import React, { FC, memo, useContext } from 'react'
import RendererContext from '../contexts/renderer-context'
import Header from './Header'
import HierarchyRow from './HierarchyRow'
import Row from './Row'
import { stores } from '@stores'

const RendererFactory: FC<{ id }> = ({ id }) =>
  useObserver(function useHook() {
    const {
      tableContext: {
        tableStore: { filteredColumns, stickyColsPosition }
      },
      root: { id: rootId, height: rootHeight },
      showBorders
    } = useContext(RendererContext)
    const {
      store: {
        getItemByComputedId,
        activeItemStore: { index }
      }
    } = useHierarchyItemContext()
    const {
      productConfiguration: { enhancedViewEnabled }
    } = stores
    const enhancedViewCell =
      enhancedViewEnabled && (rootId === 'orders' || rootId === 'deletedOrders')
        ? true
        : false
    if (rootId === id && rootHeight > 0) {
      return (
        <Header
          key={'header'}
          enhancedViewCell={enhancedViewCell}
          columns={filteredColumns}
          stickyColsPosition={stickyColsPosition}
          showBorders={showBorders}
        />
      )
    } else if (
      id.includes(INDIVIDUAL_SEPARATOR_IDENTIFIER) ||
      id.includes(PAGE_SEPARATOR_IDENTIFIER)
    ) {
      const [, rowIndex] = extractIndexFromId(id)
      return (
        <Row
          key={'row'}
          id={id}
          enhancedViewCell={enhancedViewCell}
          columns={filteredColumns}
          rowData={getItemByComputedId(id)}
          stickyColsPosition={stickyColsPosition}
          showBorders={showBorders}
          isActive={index === rowIndex}
        />
      )
    } else {
      return (
        <HierarchyRow
          key={'hierarchy-row'}
          id={id}
          enhancedViewCell={enhancedViewCell}
          columns={filteredColumns}
          rowData={getItemByComputedId(id)}
          stickyColsPosition={stickyColsPosition}
          showBorders={showBorders}
        />
      )
    }
  })
RendererFactory.displayName = 'RendererFactory'

export default memo(RendererFactory)
